export const MEDIA_QUERIES = {
	toMd: "(max-width: 767px)",
	md: "(min-width: 768px)",
	toLg: "(max-width: 1023px)",
	lg: "(min-width: 1024px)",
	xl: "(min-width: 1280px)",
	preferesReducedMotion: "(prefers-reduced-motion: reduce)",
};
